import { render } from "./ProductEn.vue?vue&type=template&id=ce3244d2&scoped=true"
import script from "./ProductEn.vue?vue&type=script&lang=js"
export * from "./ProductEn.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3244d2"]])

export default __exports__